<template>
  <v-container fluid>
    <br />
    <br />
    <v-layout>
      <v-flex class="margin-custom-width-left">
        <v-flex xs12 sm10 md6>
          <v-form ref="form" v-model="validCredentials">
            <label class="headline">Request New Key</label>
            <v-text-field
              v-model="phoneNumber"
              prepend-icon="person"
              :rules="phoneRules"
              name="login"
              label="Phone Number"
              type="text"
              mask="phone"
            ></v-text-field>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <v-btn :disabled="!validCredentials" @click="generateKey" color="primary">Request Key</v-btn>Or
            <router-link to="/login" style="text-decoration: none;">&nbsp;Login</router-link>
          </v-form>
        </v-flex>
      </v-flex>
    </v-layout>
    <br />
    <v-snackbar v-model="toast" :color="toastColor" :timeout="8000" multi-line>{{toastMessage}}</v-snackbar>
  </v-container>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import dataService from "@/data/data.service";

export default {
  data: () => ({
    toast: false,
    toastColor: "success",
    toastMessage: "New key sent as text message to phone number.",
    validCredentials: false,
    phoneNumber: "",
    phoneRules: [
      v => !!v || "Phone is required"
      //  v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),

  methods: {
    generateKey() {
      let pParams = { phoneNumber: this.phoneNumber };
      let secretKey = null;
      this.getAccount(pParams).then(() => {
        if (this.account.length !== 0) {
          secretKey = dataService.modules.secrets.getRandomKey();

          this.account[0].secretKey = secretKey;
          delete this.account[0].lastLogIn;

          this.updateAccount(this.account[0]).then(() => {
            this.textKey(this.phoneNumber, secretKey);
            this.toast = true;
            this.toastColor = "success";
            this.toastMessage = "New key sent to your mobile phone.";
          });
        } else {
          this.toast = true;
          this.toastColor = "error";
          this.toastMessage = "No user found in system.";
        }
      });
    },

    textKey(phone, secretKey) {
      let smsObj = {
        Message: `Here is your secret key: ${secretKey}`,
        MessageStructure: "string",
        PhoneNumber: `+1${phone}`
      };
      dataService.modules.sms.sendTextMessage(smsObj);
    },

    ...mapActions("auth", ["loginUser"]),
    ...mapActions("account", {
      getAccount: "get",
      updateAccount: "update"
    })
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("account", ["account"])
  }
};
</script>